import type { Board } from 'chessboard/model/board/types';
import { Coordinates } from 'chessboard/plugins/coordinates/config/types';
import { Core } from 'chessboard/core/config/types';
import { isOneOf } from 'utils/app/model/is-one-of';
import type { Plugins } from 'chessboard/core/plugins/config/types';

/**
 * Adds commands for updating coordinates position.
 */
export function createCoordinatesPlugin(): Plugins.Model {
  let coordinates: Board.CoordinatesPositions;
  let flipped = false;

  return {
    match: [
      {
        condition: isOneOf([Core.InstanceEvents.RendererSet, Core.OptionsEvents.Update]),
        handler: updateCoordinates,
      },
    ],
    name: Coordinates.Plugin.Name,
  };

  /**
   * Update the rendered coordinates.
   */
  function updateCoordinates(event: Core.Event, context: Core.Context) {
    const { options, renderer } = context;

    if (!renderer) {
      return;
    }

    if (
      options.coordinates !== coordinates ||
      options.flipped !== flipped ||
      event.type === Core.InstanceEvents.RendererSet
    ) {
      renderer.setCoordinates(
        {
          flipped: options.flipped,
          position: options.coordinates,
        },
        context,
      );
    }

    coordinates = options.coordinates;
    flipped = options.flipped;
  }
}
